import { t } from "i18next";
import { Athlete, AthleteMeasurement } from "../../interfaces/athlete";
import moment from 'moment';
import ReactECharts from 'echarts-for-react';
import chartsIcon from "../../assets/images/charts.svg";

interface AthleteWeightChartProps {
    athlete: Athlete;
}

export function AthleteWeightChart(props: AthleteWeightChartProps) {
    const options = {
        xAxis: {
            type: 'category',
            data: props.athlete.measurement.map((m: AthleteMeasurement) => {
                return moment(m.measurement_date).format('DD/MM');
            })
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: '{value} kg'
            }
        },
        series: [
            {
                data: props.athlete.measurement.map((m: AthleteMeasurement) => {
                    return m.weight;
                }),
                type: 'line',
                smooth: true,
                label: {
                    show: true,
                    position: 'top',
                    formatter: '{c} kg'
                }
            }
        ]
    }

    return (
        <div className="athlete-weight-chart-container chart-box">
            <h3 className="chart-title">
                <img src={ chartsIcon } alt={ t("weight")} />
                { t("weight") }
            </h3>
            <div className="chart-content">
                <ReactECharts option={ options } />
            </div>
        </div>
    );
}